// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kabutops: PokeData = {
  "id": 141,
  "name": "kabutops",
  "height": 13,
  "weight": 405,
  "base_experience": 173,
  "types": [
    PokeType.ROCK,
    PokeType.WATER
  ],
  "api_moves": [
    "scratch",
    "swords-dance",
    "sand-attack",
    "leer",
    "hydro-pump",
    "absorb",
    "mega-drain",
    "rock-throw",
    "screech",
    "harden",
    "confuse-ray",
    "leech-life",
    "rock-slide",
    "slash",
    "protect",
    "endure",
    "fury-cutter",
    "ancient-power",
    "metal-sound",
    "mud-shot",
    "brine",
    "feint",
    "wring-out",
    "night-slash",
    "stone-edge",
    "aqua-jet",
    "liquidation"
  ],
  "moves": [
    "scratch",
    "leer",
    "hydro-pump",
    "rock-throw",
    "confuse-ray",
    "rock-slide",
    "protect",
    "ancient-power",
    "metal-sound",
    "mud-shot",
    "brine",
    "night-slash",
    "aqua-jet"
  ],
  "evolution_chain": {
    "id": 70,
    "item": null,
    "species": [
      {
        "name": "kabuto",
        "order": 171,
        "types": [
          PokeType.ROCK,
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "kabutops",
        "order": 172,
        "types": [
          PokeType.ROCK,
          PokeType.WATER
        ],
        "evolves_from_species_id": 140,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 110,
    "speed": 119,
    "ability_power": 171
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
